import React from 'react';
import CustomImage from '../../components/custom-image';
const ProvenTrackRecord = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="two-columns-one">
          <div className="left-text">
            <p>
              Our management team has a diverse and extensive range of sector and global experience, which ensures that
              operations are run efficiently and responsibly, with key insights. We have taken a disciplined approach to
              development, growing our production steadily across our operations with an ongoing focus on operational
              efficiency and cost savings. Since our listing in 2003, our assets have delivered an average of 15% CAGR
              production growth.
            </p>
          </div>
          <div className="right-image">
            <div className="desktop-img">
              <CustomImage className="custom-image" imageName="invetment-proven-track-record.png" alt="Proven Track Record" maxWidth="768" />
            </div>
            <div className="mobile-img">
              <CustomImage className="custom-image" imageName="invetment-proven-track-record-mobile.png" alt="Proven Track Record" maxWidth="768" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProvenTrackRecord;
